import { Link } from "react-router";
import { listCollection } from "../lib/content.server.js";
import { buildMeta } from "../lib/seo.js";
import PageHero from "../components/PageHero/PageHero.jsx";
import EntryCard from "../components/EntryCard/EntryCard.jsx";
import SectionHeader from "../components/SectionHeader/SectionHeader.jsx";
import styles from "./resources.module.css";

const PAGE = {
  title: "Resources",
  description:
    "Articles, recorded webinars, whitepapers and press about road safety audits and infrastructure visualization.",
  path: "/resources",
};
const HUBS = [
  {
    href: "/blog",
    title: "Blog",
    text: "Articles on road safety audits, sight distance and visualization.",
  },
  {
    href: "/resources/webinars",
    title: "Webinars",
    text: "Sessions on RSA 3D for existing roads and new designs.",
  },
  {
    href: "/resources/whitepapers",
    title: "Whitepapers",
    text: "Downloads and our statement of qualifications.",
  },
  { href: "/resources/press", title: "Press", text: "Releases and coverage." },
];

export function meta() {
  return buildMeta(PAGE);
}

export async function loader() {
  return { latest: listCollection("blog").slice(0, 3) };
}

export default function Resources({ loaderData }) {
  return (
    <>
      <PageHero eyebrow="Resources" title="Learn before you buy" lead={PAGE.description} />
      <section className="section">
        <div className="container">
          <ul className="grid grid-4">
            {HUBS.map((h) => (
              <li key={h.href} className={styles.card}>
                <h2 className={styles.cardTitle}>
                  <Link to={h.href}>{h.title}</Link>
                </h2>
                <p className={styles.cardText}>{h.text}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>
      <section className="section section-alt">
        <div className="container">
          <SectionHeader eyebrow="Latest articles" title="From the blog" />
          <div className="grid grid-3">
            {loaderData.latest.map((p) => (
              <EntryCard
                key={p.slug}
                kind="post"
                href={`/blog/${p.slug}`}
                image={p.image}
                imageAlt={p.imageAlt}
                title={p.title}
                description={p.description}
                meta={p.date}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
